/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemConstructionCategories = 'NotSpecified' | 'StructuralEngineering' | 'CivilEngineering';

export const ItemConstructionCategories = {
    NotSpecified: 'NotSpecified' as ItemConstructionCategories,
    StructuralEngineering: 'StructuralEngineering' as ItemConstructionCategories,
    CivilEngineering: 'CivilEngineering' as ItemConstructionCategories
};

